<ideal-wire-cut-item-description-view [item]="item()" />
